import styled from "styled-components";

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AddIconContainer = styled.div`
  margin-left: 16px;
  &:hover {
    cursor: pointer;
  }
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(100px, 1fr) );
  align-items: center;
  gap: 32px;
  width: 100%;

  ${props => props.theme.mediaQuerie.maxWidth.md}{
    gap: 16px;
    grid-template-areas: 
    "title title"
    "input-one input-two";

    >div {
      &:nth-child(1) {
        grid-area: title;
      }

      &:nth-child(2) {
        grid-area: input-one;
      }

      &:nth-child(3) {
        grid-area: input-two;
      }
    }
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 16px;
  flex: 1;

  ${props => props.theme.mediaQuerie.maxWidth.md}{
    background-color: ${props => props.theme.colors.inputBackground};
    border-radius: 8px;
    padding: 16px;
    gap: 16px;
  }
`;